import { WorkoutsRepository } from "../../infra/repository/workout.repository";

export class DeleteWorkoutUseCase {
    static async execute(workoutId: string): Promise<void> {
        try {
            const response = await WorkoutsRepository.delete(workoutId);
            if (response.error) {
                throw Error("Erro ao excluir treino");
            }
        } catch (error) {
            throw Error("Erro ao excluir treino");
        }
    }
}
